<mat-toolbar class="toolbar">
  <div class="toolbar-icons-left" *transloco="let t">
    @if(!hideSidenavMenu) {
      <xt-portal-button
        class="sidenav-switcher mobile"
        [xTentionDummyCypress]="'dashboard-shell.toolbar.toggle'"
        [ariaLabel]="t('app.dashboard.sidebar.ariaLabel')"
        icon="text"
        color="none"
        width="small"
        (clickEvent)="openSidenav()"
        />
      }
      <img
        [routerLink]="'/dashboard'"
        class="logo"
        src="./../../../../assets/Curamenta_Logo.svg"
        alt="Curamenta Logo"
        width="75"
        height="43"
        [xTentionDummyCypress]="'dashboard-shell.toolbar.navigate.dashboard'"
        />
      </div>

      <div class="toolbar-icons-right">
        @if (
          (isUserRolePatient$ | async) || (isUserRoleRepresentative$ | async)
          ) {
          <a
            [href]="emergencyButtonUrl"
            target="_blank"
            rel="noopener noreferrer"
            tabindex="-1"
            [xTentionDummyCypress]="'dashboard-shell.toolbar.navigate.emergency'"
            [attr.title]="'app.dashboard.emergency' | transloco"
            [attr.aria-label]="'app.dashboard.emergency' | transloco"
            >
            <mat-icon class="emergency-icon-header" svgIcon="bandage"></mat-icon>
          </a>
        }

        @if (
          (isUserRolePatient$ | async) ||
          (isUserRoleProvider$ | async) ||
          (isUserRoleRepresentative$ | async)
          ) {
          <xt-portal-notification-indicator
            [xTentionDummyCypress]="'dashboard.header.notification-indicator'"
            (toggleMenuEvent)="toggleMenu()"
            />
        }
        @if (partnerLogoUrl) {
          <img
            [src]="partnerLogoUrl"
            class="logo-toolbar"
            alt="Partner Logo"
            loading="lazy"
            tabindex="0"
            />
        }
        <div
          [ngClass]="{ active: isProfileActive }"
          [xTentionDummyCypress]="'dashboard.header.user'"
          class="user"
          >
          @if(isOnboardingLevelFull$ | async) {
            <xt-portal-avatar
              [abbreviation]="acronym"
              [isSmallBubble]="true"
              role="button"
              tabindex="0"
              [xTentionDummyCypress]="'dashboard.header.avatar'"
              (keydown.enter)="openUserDialog()"
              (click)="openUserDialog()"
              />
            } @else {
              <mat-icon (click)="openUserDialog()" (keydown.enter)="openUserDialog()">
                person
              </mat-icon>
            }
            <xt-portal-button
              [text]="name"
              color="none"
              class="username"
              iconPosition="right"
              icon="chevron-down"
              width="small"
              [ariaLabel]="'app.labels.username' | transloco"
              [disableRipple]="true"
              [xTentionDummyCypress]="'dashboard.header.user-name'"
              (clickEvent)="openUserDialog()"
              />
            </div>
          </div>
        </mat-toolbar>
